"use client";
import {
  HovercardContextProvider,
  HovercardScopedContextProvider
} from "./EM5CXX6A.js";
import {
  createStoreContext
} from "./LMDWO4NN.js";

// src/tooltip/tooltip-context.tsx
var ctx = createStoreContext(
  [HovercardContextProvider],
  [HovercardScopedContextProvider]
);
var useTooltipContext = ctx.useContext;
var useTooltipScopedContext = ctx.useScopedContext;
var useTooltipProviderContext = ctx.useProviderContext;
var TooltipContextProvider = ctx.ContextProvider;
var TooltipScopedContextProvider = ctx.ScopedContextProvider;

export {
  useTooltipContext,
  useTooltipScopedContext,
  useTooltipProviderContext,
  TooltipContextProvider,
  TooltipScopedContextProvider
};
